// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */

body {
  font-family: 'PT Sans', 'Gill Sans', "Gill Sans MT", 'Calibri', "Trebuchet MS",
  sans-serif;
}


.navbar {
  background-color: #000;
  border-bottom: 4px solid #74081f;
}

.nav-link {
  color: #ffffff;
  margin: 0 10px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  text-decoration: none;
}


.nav-link.active {
  font-weight: bold;
  -webkit-text-decoration: solid;
          text-decoration: solid;
  color: #ffffff;
  
  
}

.nav-link:hover {
  color: #cccccc;
}

.navbar-brand {
  font-weight: bold;
}

.gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-grow: 1;
}

.image-container {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.333% - 20px);
  margin: 10px;
  cursor: pointer;
  box-sizing: border-box;
}

.img-fluid {
  width: 100%;
  height: auto;
}

.pagination {
  display: flex;
  justify-content: center;
  padding: 20px;
  list-style: none;
}

.page-item {
  margin: 0 5px;
}

.page-link {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 50px;
  text-decoration: none;
  color: #74081f;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
}

.page-link:hover {
  background-color: #74081f;
  border-color: #ff0000;
  color: #fff;
}

.page-item.active .page-link {
  background-color: #74081f;
  border-color: #74081f;
  color: #fff;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  overflow: hidden;
}

.modal-content {
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.modal-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.btn-close-modal {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
}
.footer {
  background-color: #000000;
  color: #ffffff;
  padding: 20px 0;
  border-top: 2px solid #74081f;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAGhB;EACE;YACU;AACZ;;;AAGA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;;AAGA;EACE,iBAAiB;EACjB,8BAAsB;UAAtB,sBAAsB;EACtB,cAAc;;;AAGhB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAA8B;EAA9B,cAA8B;EAA9B,gCAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B","sourcesContent":["/* src/App.css */\n@import url('https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap');\n\nbody {\n  font-family: 'PT Sans', 'Gill Sans', \"Gill Sans MT\", 'Calibri', \"Trebuchet MS\",\n  sans-serif;\n}\n\n\n.navbar {\n  background-color: #000;\n  border-bottom: 4px solid #74081f;\n}\n\n.nav-link {\n  color: #ffffff;\n  margin: 0 10px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  text-decoration: none;\n}\n\n\n.nav-link.active {\n  font-weight: bold;\n  text-decoration: solid;\n  color: #ffffff;\n  \n  \n}\n\n.nav-link:hover {\n  color: #cccccc;\n}\n\n.navbar-brand {\n  font-weight: bold;\n}\n\n.gallery {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  flex-grow: 1;\n}\n\n.image-container {\n  flex: 1 1 calc(33.333% - 20px);\n  margin: 10px;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.img-fluid {\n  width: 100%;\n  height: auto;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n  list-style: none;\n}\n\n.page-item {\n  margin: 0 5px;\n}\n\n.page-link {\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 50px;\n  text-decoration: none;\n  color: #74081f;\n  transition: background-color 0.3s, border-color 0.3s, color 0.3s;\n}\n\n.page-link:hover {\n  background-color: #74081f;\n  border-color: #ff0000;\n  color: #fff;\n}\n\n.page-item.active .page-link {\n  background-color: #74081f;\n  border-color: #74081f;\n  color: #fff;\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n  overflow: hidden;\n}\n\n.modal-content {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.modal-content img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.btn-close-modal {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n.footer {\n  background-color: #000000;\n  color: #ffffff;\n  padding: 20px 0;\n  border-top: 2px solid #74081f;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
